var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.story.content.component,{tag:"component",attrs:{"blok":_vm.story.content}})}
var staticRenderFns = []

export { render, staticRenderFns }